export default {
  notfound: {
    title: 'Esta página aún no se ha generado',
    hint: 'Cuénteme más sobre esta página para poder generarla',
  },
};